/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectTaxesTaxPrmsCopyCreate } from '../fn/taxes-copy/project-taxes-tax-prms-copy-create';
import { projectTaxesTaxPrmsCopyCreate$FormData } from '../fn/taxes-copy/project-taxes-tax-prms-copy-create-form-data';
import { ProjectTaxesTaxPrmsCopyCreate$FormData$Params } from '../fn/taxes-copy/project-taxes-tax-prms-copy-create-form-data';
import { ProjectTaxesTaxPrmsCopyCreate$Params } from '../fn/taxes-copy/project-taxes-tax-prms-copy-create';
import { projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded } from '../fn/taxes-copy/project-taxes-tax-prms-copy-create-x-www-form-urlencoded';
import { ProjectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded$Params } from '../fn/taxes-copy/project-taxes-tax-prms-copy-create-x-www-form-urlencoded';
import { BackendTaxPrmDto } from '../models/backend-tax-prm-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiTaxesCopyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesTaxPrmsCopyCreate()` */
  static readonly ProjectTaxesTaxPrmsCopyCreatePath = '/api/project_taxes/tax_prms/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsCopyCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxPrmsCopyCreate$Response(
    params: ProjectTaxesTaxPrmsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsCopyCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxPrmsCopyCreate(
    params: ProjectTaxesTaxPrmsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsCopyCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsCopyCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxPrmsCopyCreate$FormData$Response(
    params: ProjectTaxesTaxPrmsCopyCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsCopyCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsCopyCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxPrmsCopyCreate$FormData(
    params: ProjectTaxesTaxPrmsCopyCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsCopyCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }
}
